module.exports = __webpack_public_path__ + "static/media/18luohanshanadj.ffe732c6.png";